import Cookies from "./cookies";
const SERP_CART_TOKEN_LS = '__isp_cart';
const SERP_CART_TOKEN = '__isp_cart_last_known';
export default function saveToken(token) {
    const cookies = new Cookies();
    /* save to global reporting keys */
    localStorage.setItem(SERP_CART_TOKEN_LS, token);
    cookies.set(SERP_CART_TOKEN, token);
    /* refresh token in reporting module if exist */
    if (typeof FastSimonReporting !== "undefined") {
        FastSimonReporting.refreshCartToken();
    }
}
//# sourceMappingURL=saveToken.js.map